import Raster_01 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-01.svg';
import Raster_02 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-02.svg';
import Raster_03 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-03.svg';
import Raster_04 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-04.svg';
import Raster_05 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-05.svg';
import Raster_06 from '../../../../theme/assets/images/BrandBlock/FCMH-Raster-06.svg';

export const SVG_VARIANTS = [
  Raster_01,
  Raster_02,
  Raster_03,
  Raster_04,
  Raster_05,
  Raster_06,
];
